import React, { useState } from "react";
import "./style.css";
import "./styles.scss";
import { useTranslation } from 'react-i18next';
import HTMLReactParser from "html-react-parser";
const FaqItem = (props) => {
  const { t } = useTranslation();
  const { question } = props;
  const [item, setItem] = useState(false);
  const [item1, setItem1] = useState(false);
  const [item2, setItem2] = useState(false);
  const [item3, setItem3] = useState(false);
  const [item4, setItem4] = useState(false);
  const [item5, setItem5] = useState(false);
  const [item6, setItem6] = useState(false);
  const [item7, setItem7] = useState(false);
  const [item8, setItem8] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [hidden1, setHidden1] = useState(false);
  const [hidden2, setHidden2] = useState(false);
  const [hidden3, setHidden3] = useState(false);
  const [hidden4, setHidden4] = useState(false);
  const [hidden5, setHidden5] = useState(false);
  const [hidden6, setHidden6] = useState(false);
  const [hidden7, setHidden7] = useState(false);
  const [hidden8, setHidden8] = useState(false);

  // useEffect(() => {
  //   
  // }, []);
  const handleitem = () => {
    setItem(true);
  };
  const handle = () => {
    setItem1(true);
  };
  const handle2 = () => {
    setItem2(true);
  };
  const handle3 = () => {
    setItem3(true);
  };
  const handle4 = () => {
    setItem4(true);
  };
  const handle5 = () => {
    setItem5(true);
  };
  const handle6 = () => {
    setItem6(true);
  };
  const handle7 = () => {
    setItem7(true);
  };
  const handle8 = () => {
    setItem8(true);
  };
  // const faqsData = [
  //   {
  //     id: 0,
  //     questionText: 'What is IRC?',
  //     answerText:
  //       'IRC is an Industry Ready Certification that represents your readiness for a job with the necessary skills.',
  //   },
  //   {
  //     id: 1,
  //     questionText: 'What is the medium of data?',
  //     answerText:
  //       'The courses would be delivered in English and Telugu. The program will be available in more vernacular languages soon.',
  //   },
  //   {
  //     id: 2,
  //     questionText:
  //       'Is there an EMI option to pay ',
  //     answerText:
  //       'Yes, EMI support is available for credit cards. Please select EMI option while making payment for more information.',
  //   },
  //   {
  //     id: 3,
  //     questionText: 'How will my doubts be cleared? ',
  //     answerText:
  //       'You can ask your doubts in the discussions section and course mentor will answer them. You can also see the doubts asked by other students.',
  //   },
  //   {
  //     id: 4,
  //     questionText: 'How will my doubts be cleared? ',
  //     answerText:
  //       'You can ask your doubts in the discussions section and course mentor will answer them. You can also see the doubts asked by other students.',
  //   },
  //   {
  //     id: 5,
  //     questionText: 'How will my doubts be cleared? ',
  //     answerText:
  //       'You can ask your doubts in the discussions section and course mentor will answer them. You can also see the doubts asked by other students.',
  //   },
  // ];
  const tabledata = [
    {
      factor: "Total number of days taken to respond to startup's request	",
      weightage: 30,
      InductiveParam: "Total mentoring hours in the last quarter<br></br>"+
      "a. Less than 15 hours (50% Marks)"+"</br>"+
      "b. 15-30 hours (75% Marks)"+"</br>"+
      "c. >30 hours (100% Marks)"+"</br>"
    },
    {
      factor: "Number of days taken to respond to startup's request		",
      weightage: 30,
      InductiveParam: "Average number of days in the last quarter<br></br>"+
      "a. More than 14 days (25% Marks)"+"</br>"+
      "b. From 7 to 14 days (50% Marks)"+"</br>"+
      "c. <7 days (100%  Marks)"+"</br>"
    },
    {
      factor: "Rating and feedback received from startups		",
      weightage: 30,
      InductiveParam: "Average rating of startups in the last quarter<br></br>"+
      "a. less than 3 starts (25% Marks)"+"</br>"+
      "b. 3-4 stars (50% Marks)"+"</br>"+
      "c. 4+ stars (100% Marks)"+"</br>"
    },
    {
      factor: "Number of startups graduated by the mentor (Bonus Marks). A startup is considered a graduate when its mentorship needs are met, is able to show tangible outcomes, or is able to move to the next stage",
      weightage: 30,
      InductiveParam: "Total mentoring hours in the last quarter<br></br>"+
      "a. Fewer than 3 startups (25% marks)"+"</br>"+
      "b. 3-5 startups (50% Marks)"+"</br>"+
      "c. 5+ startups (100% Marks)"+"</br>"
    },
  ]
  return (
    <div>
      {/* <div>
      {faqsData.map((user) => (
      <div className="user">{user.questionText}</div>
    ))}
      </div> */}
      {question === 1 ? (
        <div>
          <div className="faq faq-div">
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handleitem();
                setItem1(false);
                setItem(!hidden);
                setItem2(false);
                setItem3(false);
                setItem4(false);
                setItem5(false);
                setHidden1(false);
                setHidden(!hidden);
                setHidden2(false);
                setHidden3(false);
                setHidden4(false);
                setHidden5(false);
              }}
            >
              {t('What_is_MAARG_Portal')}
              {/* What is MAARG Portal? */}
            </div>
            {hidden && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('The_MAARG_Portal_by_Startup_India')}
                {/* The MAARG Portal by Startup India is a one-stop
                platform which will be hosted on the */}
                <a
                  href="https://www.startupindia.gov.in"
                  target="_blank"
                  style={{ color: "#0d6efd", position: "relative", marginLeft: "12px" }}
                >
                  {localStorage.getItem("SelectedLang")=="en"&& t('Startup_India_portal')}
                  {/* Startup India portal */}
                </a>{" "}
                {localStorage.getItem("SelectedLang")=="en"&& t('facilitate_startups')}
                {/* to facilitate startups across sectors, functions, stages,
                geographies, and backgrounds to receive mentorship from experts.
                Startups can leverage the platform to connect with academicians,
                industry experts, unicorn, and soonicorn founders, seasoned
                investors, etc. to get one-to-one advice on their business. */}
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle();
                setItem1(!hidden1);
                setItem(false);
                setItem2(false);
                setItem3(false);
                setItem4(false);
                setItem5(false);
                setHidden(false);
                setHidden1(!hidden1);
                setHidden2(false);
                setHidden3(false);
                setHidden4(false);
                setHidden5(false);
              }}
            >
              {t('How_does_the_platform_work')}
              {/* How does the platform work? */}
            </div>
            {hidden1 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('Each_user_can_register')}
                {/* Each user can register on the platform as a Mentor or Startup.
                After publishing of the profile, the platform will matchmake
                mentors and Startups using artificial intelligence based on
                sector, stage, and functional skillset. Either party can send a
                connection request to a desired mentor/Startup and once the
                request is accepted, the mentorship can be started. Each
                mentorship connection will be tracked for evaluating progress
                and feedback. Following the sessions, the mentors and Startups
                will be prompted to update the session details in their
                respective dashboards namely duration of session, specific topic
                etc. In case the sessions are not updated, the users will not be
                able to proceed further for scheduling the next session. Note:
                The mentorship session videos and chats may be recorded for
                quality purposes. */}
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle2();
                setItem2(!hidden2);
                setItem(false);
                setItem1(false);
                setItem3(false);
                setItem4(false);
                setItem5(false);
                setHidden(false);
                setHidden2(!hidden2);
                setHidden1(false);
                setHidden3(false);
                setHidden4(false);
                setHidden5(false);
              }}
            >
              {t('What_is_a_cohort_based_program')}
              {/* What is a cohort-based program? */}
            </div>
            {hidden2 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('Cohort_based_programs_will_be_hosted')}
                {/* Cohort-based programs (CBP) will be hosted on the mentorship
                portal in collaboration with partners from the Startup
                ecosystem. Partners such as industry associations, incubators,
                accelerators, academia, various startup networks (for unicorns,
                successful startups, professionals, etc.), amongst others shall
                be able to host cohort-based, limited-duration mentorship
                programs on the portal. CBP can also be hosted during marquee
                events by Startup India, such as Prarambh and SCO Startup Forum.
                Note: The mentorship session videos and chats may be recorded
                for quality purposes. */}
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle3();
                setItem3(!hidden3);
                setItem(false);
                setItem1(false);
                setItem2(false);
                setItem4(false);
                setItem5(false);
                setHidden(false);
                setHidden3(!hidden3);
                setHidden1(false);
                setHidden2(false);
                setHidden4(false);
                setHidden5(false);
              }}
            >
              {t('Is_this_a_paid_mentorship_platform')}
              {/* Is this a paid mentorship platform? */}
            </div>
            {hidden3 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('the_mentorship_offerings')}
                {/* No, the mentorship offerings provided on the platform are
                completely pro bono. */}
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle4();
                setItem4(!hidden4);
                setItem(false);
                setItem1(false);
                setItem2(false);
                setItem3(false);
                setItem5(false);
                setHidden(false);
                setHidden4(!hidden4);
                setHidden1(false);
                setHidden2(false);
                setHidden3(false);
                setHidden5(false);
              }}
            >
              {t('What_is_the_validity')}
              {/* What is the validity of my registration on this portal? */}
            </div>
            {hidden4 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('For_mentors_there_is_no_period')}
                {/* For mentors, there is no period of expiry of membership on this
                portal. Startups can participate in the program as long as they
                have a valid DPIIT recognition certificate. */}
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle5();
                setItem5(!hidden5);
                setItem(false);
                setItem1(false);
                setItem2(false);
                setItem3(false);
                setItem4(false);
                setHidden(false);
                setHidden5(!hidden5);
                setHidden1(false);
                setHidden2(false);
                setHidden3(false);
                setHidden4(false);
              }}
            >
              {t('Under_what_circumstances')}
              {/* Under what circumstances will my enrolment to the program be
              removed? */}
            </div>
            {hidden5 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('Mentors_or_Startups')}
                {/* Mentors or Startups can be removed from the program for a
                definite or indefinite time by DPIIT in the following cases,
                including but not limited to: */}
                <ol type="a">
                  <li className="bottomLi">
                  {t('No_response_to_more_than_mentorship')}
                    {/* No response to more than 5 mentorship requests for 30 days
                    shall be considered as non-responsiveness. */}
                  </li>
                  <li className="bottomLi">
                  {t('More_than_feedback')}
                    {/* More than 75% feedback found to be negative from mentors or
                    Startups. */}
                  </li>
                  <li className="bottomLi">
                  {t('In_case_of_misbehaviour')}
                    {/* In case of misbehaviour or misconduct reported by mentor or
                    Startup. */}
                  </li>
                  <li className="bottomLi">
                  {t('Dissemination_of_misleading')}
                    {/* Dissemination of misleading information or socially
                    unacceptable content. */}
                  </li>
                  <li className="bottomLi">
                  {t('Information_submitted')}
                    {/* Information submitted in the application form found to be
                    false. */}
                  </li>
                  <li className="bottomLi">
                  {t('Unauthorized_advertisement_of_any_entity')}
                    {/* Unauthorized advertisement of any entity, program,
                    individual, product, etc. */}
                  </li>
                  <li className="bottomLi">
                  {t('Request_for_any_monetary')}
                    {/* Request for any monetary or non-monetary benefit for
                    mentorship. */}
                  </li>
                  <li className="bottomLi">
                  {t('Any_other_reason_noted')}
                    {/* Any other reason noted by DPIIT as inappropriate conduct. */}
                  </li>
                </ol>
                {t('In_the_above_listed_cases')}
                {/* In the above-listed cases, the decision to remove any user will
                be taken after investigation of matter by DPIIT (except a and
                b). */}
              </div>
            )}
            <div className="bottomLine"></div>
          </div>
        </div>
      ) : question === 2 ? (
        <div>
          <div className="faq faq-div">
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handleitem();
                setItem1(false);
                setItem(!hidden);
                setItem2(false);
                setItem3(false);
                setItem4(false);
                setItem5(false);
                setItem6(false);
                setItem7(false);
                setHidden1(false);
                setHidden(!hidden);
                setHidden2(false);
                setHidden3(false);
                setHidden4(false);
                setHidden5(false);
                setHidden6(false);
                setHidden7(false);
              }}
            >
              {t('Am_eligible_Startup')}
              {/* Am I eligible to be a Startup? */}
            </div>
            {hidden && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('DPIIT_recognized_startups')}
                {/* All DPIIT-recognized startups, from all sectors and stages of
                startup lifecycle, are eligible to apply for mentorship on the
                platform all year-round. */}
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle();
                setItem1(!hidden1);
                setItem(false);
                setItem2(false);
                setItem3(false);
                setItem4(false);
                setItem5(false);
                setItem6(false);
                setItem7(false);
                setHidden(false);
                setHidden1(!hidden1);
                setHidden2(false);
                setHidden3(false);
                setHidden4(false);
                setHidden5(false);
                setHidden6(false);
                setHidden7(false);
              }}
            >
              {t('How_can_i_get_recognized_as_startup')}
              {/* How can i get recognized as a startup by DPIIT? */}
            </div>
            {hidden1 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('How_can_i_get_recognized_under')}
                {/* Under the Startup India initiative, eligible companies can get
                recognised as Startups by Department for Promotion of Industry
                and Internal Trade (DPIIT), in order to access a host of
                benefits by the Government of India. An entity which fulfils the
                eligibility conditions as notified in G.S.R. 127 (E) issued by
                DPIIT dated 19th February 2019 can apply for DPIIT Recognition
                on the{" "} */}
                <a
                  style={{ color: "#0d6efd" }}
                  href="https://www.startupindia.gov.in/content/sih/en/recognition-page.html"
                >
                  {localStorage.getItem("SelectedLang")=="en"&& t('Startup_India_portal')}
                  {/* Startup India portal. */}
                </a>.
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle2();
                setItem2(!hidden2);
                setItem(false);
                setItem1(false);
                setItem3(false);
                setItem4(false);
                setItem5(false);
                setItem6(false);
                setItem7(false);
                setHidden(false);
                setHidden1(false);
                setHidden2(!hidden2);
                setHidden3(false);
                setHidden4(false);
                setHidden5(false);
                setHidden6(false);
                setHidden7(false);
              }}
            >
              {t('How_can_i_find_mentor')}
              {/* How can i find a mentor? */}
            </div>
            {hidden2 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('registration_and_publishing')}
                {/* After registration and publishing of your profile, the platform
                will matchmake mentors and Startups using artificial
                intelligence based on sector, stage, and functional skillset.
                Either party can send a connection request to a desired
                mentor/Startup and once the request is accepted, the mentorship
                can be started. Multiple mentors can be assigned to a Startup
                and vice versa. */}
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle3();
                setItem3(!hidden3);
                setItem2(false);
                setItem1(false);
                setItem4(false);
                setItem(false);
                setItem5(false);
                setItem6(false);
                setItem7(false);
                setHidden(false);
                setHidden3(!hidden3);
                setHidden1(false);
                setHidden2(false);
                setHidden4(false);
                setHidden5(false);
                setHidden6(false);
                setHidden7(false);
              }}
            >
              {t('What_happens_if_the_mentor')}
              {/* What happens if the mentor I reach out to is unresponsive? */}
            </div>
            {hidden3 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('multiple_mentorship_requests')}
                {/* The portal is enabled to send multiple mentorship requests to
                several mentors at the same time. In case, any mentor is not
                responding to the request within 15 working days, the request
                will be pulled back and a new set of mentors will be suggested. */}
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle4();
                setItem4(!hidden4);
                setItem3(false);
                setItem2(false);
                setItem1(false);
                setItem5(false);
                setItem6(false);
                setItem7(false);
                setItem(false);
                setHidden(false);
                setHidden4(!hidden4);
                setHidden3(false);
                setHidden1(false);
                setHidden2(false);
                setHidden5(false);
                setHidden6(false);
                setHidden7(false);
              }}
            >
              {t('What_duration_the_mentorship')}
              {/* What will be the duration of the mentorship? */}
            </div>
            {hidden4 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('mentorship_duration_mutually')}
                {/* The mentorship duration shall be mutually between the mentor and
                Startup for a definite time period. */}
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle5();
                setItem4(false);
                setItem5(!hidden5);
                setItem3(false);
                setItem2(false);
                setItem1(false);
                setItem6(false);
                setItem7(false);
                setItem(false);
                setHidden(false);
                setHidden4(false);
                setHidden5(!hidden5);
                setHidden3(false);
                setHidden1(false);
                setHidden2(false);
                setHidden6(false);
                setHidden7(false);
              }}
            >
              {t('Will_the_mentorship_be_virtual_or_in_person')}
              {/* Will the mentorship be virtual or in person? */}
            </div>
            {hidden5 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('The_portal_allows_both')}
                {/* The portal allows both formats for mentorship interactions and
                the same can be decided mutually between the parties. The
                virtual meetings can be scheduled and tracked automatically on
                the portal. Physical meetings can be scheduled using the portal
                and details can be entered manually after the interaction. */}
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle6();
                setItem4(false);
                setItem6(!hidden6);
                setItem5(false);
                setItem3(false);
                setItem2(false);
                setItem1(false);
                setItem7(false);
                setItem(false);
                setHidden(false);
                setHidden4(false);
                setHidden6(!hidden6);
                setHidden5(false);
                setHidden3(false);
                setHidden1(false);
                setHidden2(false);
                setHidden7(false);
              }}
            >
              {t('Do_i_need_to_pay_any_fee')}
              {/* Do i need to pay any fee for the mentorship? */}
            </div>
            {hidden6 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('the_mentorship_offerings_no')}
                {/* No, the mentorship offerings provided on the platform are
                completely pro bono. */}
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle7();
                setItem4(false);
                setItem7(!hidden7);
                setItem6(false);
                setItem5(false);
                setItem3(false);
                setItem2(false);
                setItem1(false);
                setItem(false);
                setHidden(false);
                setHidden4(false);
                setHidden7(!hidden7);
                setHidden6(false);
                setHidden5(false);
                setHidden3(false);
                setHidden1(false);
                setHidden2(false);
              }}
            >
              {t('participate_in_a_cohort_based_program')}
              {/* How can i participate in a cohort-based program? */}
            </div>
            {hidden7 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('program_may_open')}
                {/* The program may open call for applications for relevant
                DPIIT-recognized startups and a cohort of startups may be
                selected. Please check open cohort-based programs to apply for
                the same. */}
              </div>
            )}
            <div className="bottomLine"></div>
          </div>
        </div>
      ) : question === 3 ? (
        <div>
          <div className="faq faq-div">
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handleitem();
                setItem1(false);
                setItem(!hidden);
                setItem2(false);
                setItem3(false);
                setItem4(false);
                setItem5(false);
                setItem6(false);
                setItem7(false);
                setItem8(false);
                setHidden1(false);
                setHidden(!hidden);
                setHidden2(false);
                setHidden3(false);
                setHidden4(false);
                setHidden5(false);
                setHidden6(false);
                setHidden7(false);
                setHidden8(false);
              }}
            >
              {t('Am_I_eligible_to_be_a_mentor')}
              {/* Am I eligible to be a mentor? */}
            </div>
            {hidden && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {/* {t('The_MAARG_Portal')}
                The MAARG Portal by Startup India shall invite
                mentors to register and provide guidance to startups throughout
                the year. A potential mentor needs to have at least 7 years of
                experience in any of the below to be eligible for the program: */}
                <ul>
                  <li className="bottomLi">
                  {t('Building_a_startu')}
                    {/* Building a startup or working in a startup */}
                  </li>
                  <li className="bottomLi">
                  {t('Investing_startup')}
                    {/* Investing in a startup or helping startups raise investments */}
                  </li>
                  <li className="bottomLi">
                  {t('Running_incubator')}
                    {/* Running an incubator or working in an incubation facility */}
                  </li>
                  <li className="bottomLi">
                  {t('Running_accelerator')}
                    {/* Running an accelerator or working in an accelerator */}
                  </li>
                  <li className="bottomLi">
                  {t('Mentoring_startup')}
                    {/* Mentoring a startup in the past or being on the board of
                    advisors of a startup */}
                  </li>
                  <li className="bottomLi">
                  {t('Teaching_management')}
                    {/* Teaching management or a technical subject at a graduation
                    or postgraduation academic institution */}
                  </li>
                  <li className="bottomLi">
                  {t('Working_with_State_Government')}
                    {/* Working with a State Government, Central Government,
                    Foundation, NGO, Non-Profit Entity, or any other
                    organization to promote entrepreneurship and innovation */}
                  </li>
                  <li className="bottomLi">
                  {t('Working_business')}
                    {/* Working in a business vertical (such as marketing, HR,
                    operations, business development, website or app
                    development, etc.) */}
                  </li>
                </ul>
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle();
                setItem1(!hidden1);
                setItem(false);
                setItem2(false);
                setItem3(false);
                setItem4(false);
                setItem5(false);
                setItem6(false);
                setItem7(false);
                setItem8(false);
                setHidden(false);
                setHidden1(!hidden1);
                setHidden2(false);
                setHidden3(false);
                setHidden4(false);
                setHidden5(false);
                setHidden6(false);
                setHidden7(false);
                setHidden8(false);
              }}
            >
              {t('duration_of_the_mentorship')}
              {/* What will be the duration of the mentorship? */}
            </div>
            {hidden1 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('mentor_and_Startup')}
                {/* The mentorship duration shall be mutually between the mentor and
                Startup for a definite time period. */}
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle2();
                setItem2(!hidden2);
                setItem(false);
                setItem1(false);
                setItem3(false);
                setItem4(false);
                setItem5(false);
                setItem6(false);
                setItem7(false);
                setItem8(false);
                setHidden(false);
                setHidden1(false);
                setHidden2(!hidden2);
                setHidden3(false);
                setHidden4(false);
                setHidden5(false);
                setHidden6(false);
                setHidden7(false);
                setHidden8(false);
              }}
            >
              {t('commitment_required')}
              {/* What is the overall monthly commitment required from my side? */}
            </div>
            {hidden2 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('overall_monthly_commitment')}
                {/* The overall monthly commitment required from a mentor’s side is
                mentioned below: */}
                <ul>
                  <li className="bottomLi">
                  {t('Response_mentorship')}
                    {/* Response to mentorship request sent by the Startups within
                    15 days */}
                  </li>
                  <li className="bottomLi">
                  {t('Regular_mentorship')}
                    {/* Regular mentorship interactions with the connected startups
                    (as mutually agreed) */}
                  </li>
                  <li className="bottomLi">
                  {t('Setting_meetings')}
                    {/* Setting meetings directly from the portal and updating
                    information regarding the sessions and progress in a timely
                    fashion */}
                  </li>
                  <li className="bottomLi">
                  {t('Knowledge_sharing')}
                    {/* Knowledge sharing through one-to-many sessions, reports,
                    webinars, etc. */}
                  </li>
                </ul>
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle3();
                setItem3(!hidden3);
                setItem2(false);
                setItem1(false);
                setItem(false);
                setItem4(false);
                setItem5(false);
                setItem6(false);
                setItem7(false);
                setItem8(false);
                setHidden(false);
                setHidden3(!hidden3);
                setHidden1(false);
                setHidden2(false);
                setHidden4(false);
                setHidden5(false);
                setHidden6(false);
                setHidden7(false);
                setHidden8(false);
              }}
            >
              {t('get_Startups')}
              {/* How will I get Startups? */}
            </div>
            {hidden3 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('registration_publishing')}
                {/* After registration and publishing of your profile, the platform
                will matchmake mentors and Startups using artificial
                intelligence based on sector, stage, and functional skillset.
                Either party can send a connection request to a desired
                mentor/Startup and once the request is accepted, the mentorship
                can be started. Multiple mentors can be assigned to a Startup
                and vice versa. */}
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle4();
                setItem4(!hidden4);
                setItem2(false);
                setItem1(false);
                setItem(false);
                setItem3(false);
                setItem5(false);
                setItem6(false);
                setItem7(false);
                setItem8(false);
                setHidden(false);
                setHidden4(!hidden4);
                setHidden1(false);
                setHidden2(false);
                setHidden3(false);
                setHidden5(false);
                setHidden6(false);
                setHidden7(false);
                setHidden8(false);
              }}
            >
              {t('benefit_startup')}
              {/* What is the benefit of becoming a startup mentor? */}
            </div>
            {hidden4 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('mentor_will_enjoy')}
                {/* The mentors will enjoy a host of benefits by becoming a mentor
                on the portal. This is a great opportunity for an expert to
                share their expertise with the startup community and contribute
                indirectly to the economy & job creation of India. In addition
                to this, DPIIT and Startup India shall categorize the mentors
                into Platinum Mentors, Gold Mentors, and Silver Mentors basis
                the feedback of startups, time dedicated to mentorship, and any
                other parameters. The mentors shall receive incentives basis
                their classification. Some of the incentives include invitation
                to all Startup India’s national and international programs,
                access to networking opportunities with stakeholders, special
                coverage on the Startup India social media, Certificate from
                Startup India recognizing their contributions, amongst others. */}
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle5();
                setItem5(!hidden5);
                setItem2(false);
                setItem1(false);
                setItem(false);
                setItem3(false);
                setItem4(false);
                setItem6(false);
                setItem7(false);
                setItem8(false);
                setHidden(false);
                setHidden5(!hidden5);
                setHidden1(false);
                setHidden2(false);
                setHidden3(false);
                setHidden4(false);
                setHidden6(false);
                setHidden7(false);
                setHidden8(false);
              }}
            >
              {t('virtual_mentorship')}
              {/* Will the mentorship be virtual or in person? */}
            </div>
            {hidden5 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('mentorship_interactions')}
                {/* The portal allows both formats for mentorship interactions and
                the same can be decided mutually between the parties. The
                virtual meetings can be scheduled and tracked automatically on
                the portal. Physical meetings can be scheduled using the portal
                and details can be entered manually after the interaction. */}
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle6();
                setItem6(!hidden6);
                setItem2(false);
                setItem1(false);
                setItem(false);
                setItem3(false);
                setItem4(false);
                setItem5(false);
                setItem7(false);
                setItem8(false);
                setHidden(false);
                setHidden6(!hidden6);
                setHidden1(false);
                setHidden2(false);
                setHidden3(false);
                setHidden4(false);
                setHidden5(false);
                setHidden7(false);
                setHidden8(false);
              }}
            >
              {t('participate_cohort_based')}
              {/* Can I participate in a cohort-based program? */}
            </div>
            {hidden6 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('industry_associations')}
                {/* Partners such as industry associations, incubators,
                accelerators, academia, various startup networks (for unicorns,
                successful startups, professionals, etc.) shall host
                cohort-based, limited-duration mentorship programs on the
                portal. These partners may reach out to mentors for onboarding
                them for such a program or bring a set of mentors on their own. */}
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle7();
                setItem7(!hidden7);
                setItem2(false);
                setItem1(false);
                setItem(false);
                setItem3(false);
                setItem4(false);
                setItem5(false);
                setItem6(false);
                setItem8(false);
                setHidden(false);
                setHidden7(!hidden7);
                setHidden1(false);
                setHidden2(false);
                setHidden3(false);
                setHidden4(false);
                setHidden5(false);
                setHidden6(false);
                setHidden8(false);
              }}
            >
              {t('How_do_I_earn_badge')}
              {/* How do I earn a badge on the portal? */}
            </div>
            {hidden7 && (
              <div>
                <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('mentors_associated_with')}
                  {/* The mentors associated with the program will be scored basis
                  their performance. DPIIT and Startup India shall categorize the
                  mentor basis the feedback of startups, time dedicated, and any
                  other parameters into Platinum Mentors, Gold Mentors, and Silver
                  Mentors. The mentors shall receive incentives basis their
                  classification. */}
                </div>


                <div className="tableFaqHeading">
                {t('Mentors_Performance')}
                  {/* Mentor's Performance - Evaluation Criteria for Badges */}
                  </div>
                <div className="tableFaq">
                <table id='faqtable'>
                    <tr>
                      <th className="thfaq">
                      {/* {t('COHORT_BASED_PROGRAMS')} */}
                        Factor (to be scored out of 100)
                        </th>
                      <th className="thfaq">
                      {/* {t('COHORT_BASED_PROGRAMS')} */}
                        Weightage
                        </th>
                      <th className="thfaq">
                      {/* {t('COHORT_BASED_PROGRAMS')} */}
                        Inductive Parameters
                        </th>
                    </tr>
                  
                    {tabledata && tabledata.map((val, key) => {
                      return (
                        <tr key={key}>
                          <td width="50%">{val.factor}</td>
                          <td width="5%">{val.weightage}</td>
                          <td width="45%">{HTMLReactParser(val.InductiveParam)}</td>
                        </tr>
                      )
                    })}
                  </table>
                </div>
                <div className="faqTableBottomText" >
                {t('Quarters_will_be_synced')}
                  {/* The Quarters will be synced with financial year (April-March) */}
                  </div>
               
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle8();
                setItem8(!hidden8);
                setItem2(false);
                setItem1(false);
                setItem(false);
                setItem3(false);
                setItem4(false);
                setItem5(false);
                setItem6(false);
                setItem7(false);
                setHidden(false);
                setHidden8(!hidden8);
                setHidden1(false);
                setHidden2(false);
                setHidden3(false);
                setHidden4(false);
                setHidden5(false);
                setHidden6(false);
                setHidden7(false);
              }}
            >
              {t('participate_specific_program')}
              {/* How can a group of mentors participate in a specific program? */}
            </div>
            {hidden8 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('mentor_participate_together')}
                {/* A group of mentors can participate together by offering a
                Cohort-based Program on the portal. The cohort-based programs
                will allow a dedicated program to be hosted for a definite time. */}
              </div>
            )}
            <div className="bottomLine"></div>
          </div>
        </div>
      ) : question === 4 ? (
        <div>
          <div className="faq faq-div">
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handleitem();
                setItem1(false);
                setItem(!hidden);
                setItem2(false);
                setItem3(false);
                setItem4(false);
                // setItem5(false);
                // setItem6(false);
                // setItem7(false);
                // setItem8(false);
                setHidden1(false);
                setHidden(!hidden);
                setHidden2(false);
                setHidden3(false);
                setHidden4(false);
                // setHidden5(false);
                // setHidden6(false);
                // setHidden7(false);
                // setHidden8(false);
              }}
            >
              {t('cohort_based_program')}
              {/* What is a cohort-based program? */}
            </div>
            {hidden && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('Cohort_based_programs_hosted')}
                {/* Cohort-based programs (CBP) will be hosted on the mentorship
                portal in collaboration with partners from the startup
                ecosystem. Partners such as industry associations, incubators,
                accelerators, academia, various startup networks (for unicorns,
                successful startups, professionals, etc.) shall be able to host
                cohort-based, limited-duration mentorship programs on the
                portal. CBP can also be hosted during marquee events by Startup
                India such as Prarambh and SCO Startup Forum. */}
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle();
                setItem1(!hidden1);
                setItem(false);
                setItem2(false);
                setItem3(false);
                setItem4(false);
                // setItem5(false);
                // setItem6(false);
                // setItem7(false);
                // setItem8(false);
                setHidden(false);
                setHidden1(!hidden1);
                setHidden2(false);
                setHidden3(false);
                setHidden4(false);
                // setHidden5(false);
                // setHidden6(false);
                // setHidden7(false);
                // setHidden8(false);
              }}
            >
              {t('application_process_for_cohort_based')}
              {/* What is the application process for cohort-based programs? How
              does such a program get approved on the portal? */}
            </div>
            {hidden1 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('Indicative_process')}
                {/* Indicative process of hosting CBP are as below: */}
                <ul>
                  <li className="bottomLi">
                  {t('Register_application_management')}
                    {/* Register on the application management system of the
                    MAARG Portal */}
                  </li>
                  <li className="bottomLi">
                  {t('Screening_review')}
                    {/* Screening and review by DPIIT of the program to be hosted
                    (approval basis) */}
                  </li>
                  <li className="bottomLi">
                  {t('After_approval')}
                    {/* After approval of the application, the program will be
                    hosted on the portal for a limited period */}
                  </li>
                  <li className="bottomLi">
                  {t('program_call_for_applications')}
                    {/* The program may open call for applications to relevant
                    DPIIT-recognized startups for such a program and a cohort of
                    startups will be selected from the pool */}
                  </li>
                  <li className="bottomLi">
                  {t('program_shall_have_specific')}
                    {/* The program shall have a specific and relevant group of
                    mentors as onboarded with support of partner */}
                  </li>
                  <li className="bottomLi">
                  {t('KPIs_will_be_the_same')}
                    {/* KPIs will be the same as other mentor-Startup engagements */}
                  </li>
                </ul>
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle2();
                setItem2(!hidden2);
                setItem(false);
                setItem1(false);
                setItem3(false);
                setItem4(false);
                // setItem5(false);
                // setItem6(false);
                // setItem7(false);
                // setItem8(false);
                setHidden(false);
                setHidden1(false);
                setHidden2(!hidden2);
                setHidden3(false);
                setHidden4(false);
                // setHidden5(false);
                // setHidden6(false);
                // setHidden7(false);
                // setHidden8(false);
              }}
            >
              {t('cohort_based_mentorship_program')}
              {/* What is the duration of a cohort-based mentorship program? */}
            </div>
            {hidden2 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('mentorship_programs')}
                {/* Cohort-based mentorship programs shall be hosted on the portal
                for a limited time, which shall vary from program to program.
                There is no pre-defined timeline for hosting a program. */}
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle3();
                setItem3(!hidden3);
                setItem2(false);
                setItem1(false);
                setItem(false);
                setItem4(false);
                // setItem5(false);
                // setItem6(false);
                // setItem7(false);
                // setItem8(false);
                setHidden(false);
                setHidden3(!hidden3);
                setHidden1(false);
                setHidden2(false);
                setHidden4(false);
                // setHidden5(false);
                // setHidden6(false);
                // setHidden7(false);
                // setHidden8(false);
              }}
            >
              {t('startups_apply_for')}
              {/* How can startups apply for such a program? */}
            </div>
            {hidden3 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('program_may_open_startup')}
                {/* The program may open call for applications to relevant
                DPIIT-recognized startups and a cohort of startups can be
                selected based on their applications. Alternately, a
                pre-selected set of DPIIT recognized startups may participate in
                such programs. */}
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle4();
                setItem4(!hidden4);
                setItem2(false);
                setItem1(false);
                setItem(false);
                setItem3(false);
                // setItem5(false);
                // setItem6(false);
                // setItem7(false);
                // setItem8(false);
                setHidden(false);
                setHidden4(!hidden4);
                setHidden1(false);
                setHidden2(false);
                setHidden3(false);
                // setHidden5(false);
                // setHidden6(false);
                // setHidden7(false);
                // setHidden8(false);
              }}
            >
              {t('Does_the_program')}
              {/* Does the program host get to select startups? */}
            </div>
            {hidden4 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('applications_relevant')}
                {/* The program may open call for applications to relevant
                DPIIT-recognized startups and a cohort of startups can be
                selected based on their applications by the host. Alternately, a
                pre-selected set of DPIIT recognized startups may participate in
                such programs. */}
              </div>
            )}
            <div className="bottomLine"></div>
          </div>
        </div>
      ) : (
        <div>
          <div className="faq faq-div">
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handleitem();
                setItem1(false);
                setItem(!hidden);
                // setItem2(false);
                // setItem3(false);
                setHidden1(false);
                setHidden(!hidden);
                setHidden2(false);
                setHidden3(false);
              }}
            >
              {t('What_is_Startup_India')}
              {/* What is Startup India? */}
            </div>
            {hidden && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('Startup_India_was _launched_by_Honourable')}
                {/* Startup India was  launched by Honourable Prime Minister of India, Shri Narendra Modi on 16th January 2016
                as a clarion
                call to the innovators, entrepreneurs, and thinkers of the
                nation to lead India’s sustainable economic growth and create
                large-scale employment opportunities. Aimed to make India one of
                the largest and vigorous startup ecosystems, a 19-point Startup
                India Action Plan was launched in January 2016, which paved the
                way for a number of policy initiatives to build a strong,
                conducive, and growth-oriented environment for Indian startups.
                Five years since the launch of the initiative, India is
                witnessing a golden chapter in the history of Indian
                entrepreneurship. */}
              </div>
            )}
            <div className="bottomLine"></div>
            <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle();
                setItem1(!hidden1);
                setItem(false);
                // setItem2(false);
                // setItem3(false);
                setHidden(false);
                setHidden1(!hidden1);
                // setHidden2(false);
                // setHidden3(false);
              }}
            >
              {t('What_is_MAARG_Portal_by_Startup_India')}
              {/* What is MAARG Portal by Startup India? */}
            </div>
            {hidden1 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                {t('India_is_a_one_stop_mentorship_platform')}
                {/* The MAARG Portal by Startup India is a one stop
                mentorship platform which will be hosted on the Startup India
                portal (startupindia.gov.in) to facilitate mentorship for
                startups across diverse sectors, functions, stages, geographies,
                and backgrounds. Startups can connect with academicians,
                industry experts, unicorn or soonicorn founders, seasoned
                investors, and other experts to get personalized advice on
                growth strategy, seek clarity on things they are struggling
                with, and get practical advice on how to move forward. The core
                functions of the portal are as follows: 1. Matchmaking of
                relevant mentors and Startups 2. Tracker for mentorship
                interactions and progress 3. Video and audio calls 4.
                Mobile-friendly portal 5. Recognition for mentors 6. Hosting of
                customizable mentorship programs for ecosystem enablers 7.
                Feedback, query, and grievance mechanism for all users */}
              </div>
            )}
            <div className="bottomLine"></div>
            {/* <div
              className="btttm homepageFirstDescription"
              onClick={() => {
                handle2();
                setItem2(!hidden2);
                setItem(false);
                setItem1(false);
                setItem3(false);
                setHidden(false);
                setHidden1(false);
                setHidden2(!hidden2);
                setHidden3(false);
              }}
            >
              How can i find a mentor?
            </div>
            {hidden2 && (
              <div className="btttmtext homepageFirstDescription" style={{marginTop: '15px'}}>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime
                mollitia, molestiae quas vel sint commodi repudiandae
                consequuntur voluptatum laborum numquam blanditiis harum
                quisquam eius sed odit fugiat iusto fuga praesentium optio,
                eaque rerum! Provident
              </div>
            )}
            <div
              className="btttm"
              onClick={() => {
                handle3();
                setItem3(!hidden3);
                setItem2(false);
                setItem1(false);
                setItem(false);
                setHidden(false);
                setHidden3(!hidden3);
                setHidden1(false);
                setHidden2(false);
              }}
            >
              What happens if the mentor I reach out to is unresponsive?
            </div>
            {hidden3 && (
              <div className="btttmtext">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime
                mollitia, molestiae quas vel sint commodi repudiandae
                consequuntur voluptatum laborum numquam blanditiis harum
                quisquam eius sed odit fugiat iusto fuga praesentium optio,
                eaque rerum! Provident
              </div>
            )} */}
          </div>
        </div>
      )}
    </div>
  );
};

export default FaqItem;

// import React from 'react';
// import { Component } from 'react';

// import './style.css';

// const PLUS_IMAGE =
//   'https://assets.ccbp.in/frontend/react-js/faqs-plus-icon-img.png';
// const MINUS_IMAGE =
//   'https://assets.ccbp.in/frontend/react-js/faqs-minus-icon-img.png';

// class FaqItem extends Component {
//   state = {
//     isActive: false,
//   };

//   renderAnswer = () => {
//     const { faqData } = this.props;
//     const { answerText } = faqData;
//     const { isActive } = this.state;

//     if (isActive) {
//       return (
//         <div>
//           <hr className="horizontal-line" />
//           <p className="answer">{answerText}</p>
//         </div>
//       );
//     }
//     return null;
//   };

//   onToggleAnswer = () => {
//     this.setState((prevState) => ({
//       isActive: !prevState.isActive,
//     }));
//   };

//   renderActiveImage = () => {
//     const { isActive } = this.state;
//     const image = isActive ? MINUS_IMAGE : PLUS_IMAGE;
//     const altText = isActive ? 'minus' : 'plus';

//     return (
//         <div>
//       <button className="button" type="button" onClick={this.onToggleAnswer}>
//         <img className="faq-image"   src={image} alt={altText} />
//       </button>
//       </div>
//     );
//   };

//   render() {
//     const { faqData } = this.props;
//     const { questionText } = faqData;

//     return (
//       <li className="list-item-container">
//         <div className="question-container">
//           <h1 className="question">{questionText}</h1>
//           {this.renderActiveImage()}
//         </div>
//         {this.renderAnswer()}
//       </li>
//     );
//   }
// }

// export default FaqItem;
